export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12908.1530afc9.jpg";